import React from 'react';
export function PrivacyPage() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white" data-id="element-423">
      <div className="max-w-4xl mx-auto px-6 py-12" data-id="element-424">
        <h1 className="text-4xl font-bold bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent mb-8" data-id="element-425">
          Política de Privacidad y Protección de Datos
        </h1>

        <div className="text-gray-300 space-y-8" data-id="element-426">
          <section data-id="element-427">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-428">
              1. INTRODUCCIÓN
            </h2>
            <p className="leading-relaxed" data-id="element-429">
              En TicketMaestro y Benefika valoramos y respetamos la privacidad
              de nuestros usuarios. Esta Política de Privacidad describe cómo
              recopilamos, utilizamos, almacenamos y protegemos los datos
              personales que usted nos proporciona al utilizar nuestros sitios,
              APPs, terminales de autoatención u otros sistemas o canales de
              comunicación.
            </p>
          </section>

          <section data-id="element-430">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-431">
              2. RESPONSABLE DEL TRATAMIENTO
            </h2>
            <p className="leading-relaxed" data-id="element-432">
              <strong className="text-white" data-id="element-433">Nombre de la entidad:</strong>{' '}
              TicketMaestro SAS
              <br data-id="element-434" />
              <strong className="text-white" data-id="element-435">Dirección Legal:</strong> Edificio
              The Point, Oficina 1803, Puerto Santa Ana, Guayaquil, Ecuador.
              <br data-id="element-436" />
              <strong className="text-white" data-id="element-437">
                Correo electrónico de contacto:
              </strong>{' '}
              protecciondatos@benefika.net
            </p>
          </section>

          <section data-id="element-438">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-439">
              3. DATOS PERSONALES QUE RECOPILAMOS
            </h2>
            <p className="leading-relaxed mb-3" data-id="element-440">
              Podemos recopilar los siguientes datos personales cuando navegas o
              interactúas con nuestro sitio web u otros canales:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-441">
              <li data-id="element-442">Nombres y apellidos</li>
              <li data-id="element-443">Número de Cédula</li>
              <li data-id="element-444">Correo electrónico</li>
              <li data-id="element-445">Número de teléfono</li>
              <li data-id="element-446">
                Dirección IP y datos de navegación (cookies, ubicación, tipo de
                navegador)
              </li>
              <li data-id="element-447">
                Información proporcionada mediante formularios de contacto o
                suscripción
              </li>
            </ul>
          </section>

          <section data-id="element-448">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-449">
              4. FINALIDAD DEL TRATAMIENTO
            </h2>
            <p className="leading-relaxed mb-3" data-id="element-450">
              Recopilamos tus datos con las siguientes finalidades:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-451">
              <li data-id="element-452">
                Enviar información institucional, boletines, eventos, productos
                y servicios
              </li>
              <li data-id="element-453">
                Atender consultas o solicitudes realizadas a través de
                formularios de contacto
              </li>
              <li data-id="element-454">Gestionar inscripciones a eventos o programas</li>
              <li data-id="element-455">
                Gestionar promociones, beneficios, sistemas de fidelización y
                otras actividades de marketing
              </li>
              <li data-id="element-456">
                Realizar análisis estadísticos de navegación (uso de cookies)
              </li>
              <li data-id="element-457">Cumplir con obligaciones legales y regulatorias</li>
            </ul>
          </section>

          <section data-id="element-458">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-459">
              5. LEGITIMACIÓN PARA EL TRATAMIENTO
            </h2>
            <p className="leading-relaxed mb-3" data-id="element-460">
              El tratamiento de tus datos se realiza con base en:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-461">
              <li data-id="element-462">Tu consentimiento expreso</li>
              <li data-id="element-463">
                El interés legítimo de PromRed para cumplir su misión
                institucional
              </li>
              <li data-id="element-464">
                El cumplimiento de obligaciones legales, según la normativa
                ecuatoriana aplicable (Ley Orgánica de Protección de Datos
                Personales – LOPDP)
              </li>
            </ul>
          </section>

          <section data-id="element-465">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-466">
              6. DESTINATARIOS DE LOS DATOS
            </h2>
            <p className="leading-relaxed mb-3" data-id="element-467">
              Tus datos personales no serán compartidos con terceros, salvo que:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-468">
              <li data-id="element-469">Tengamos tu consentimiento previo</li>
              <li data-id="element-470">Sea requerido por autoridad competente conforme a la ley</li>
              <li data-id="element-471">
                Se usen herramientas tecnológicas de terceros (por ejemplo, para
                envío de newsletters, CRM o formularios) con contratos que
                garantizan la protección de tus datos
              </li>
            </ul>
          </section>

          <section data-id="element-472">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-473">
              7. DERECHOS DEL TITULAR DE LOS DATOS
            </h2>
            <p className="leading-relaxed mb-3" data-id="element-474">Tienes derecho a:</p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-475">
              <li data-id="element-476">Acceder a tus datos personales</li>
              <li data-id="element-477">Rectificar datos inexactos o incompletos</li>
              <li data-id="element-478">Eliminar tus datos (cuando proceda)</li>
              <li data-id="element-479">Oponerte al tratamiento</li>
              <li data-id="element-480">Solicitar la portabilidad de tus datos</li>
              <li data-id="element-481">Revocar el consentimiento en cualquier momento</li>
            </ul>
            <p className="leading-relaxed mt-3" data-id="element-482">
              Puedes ejercer estos derechos escribiéndonos a{' '}
              <span className="text-[#d4af37]" data-id="element-483">
                protecciondatos@benefika.net
              </span>
            </p>
          </section>

          <section data-id="element-484">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-485">
              8. USO DE COOKIES
            </h2>
            <p className="leading-relaxed" data-id="element-486">
              Nuestros sitios utilizan cookies propias y de terceros para
              mejorar la experiencia de navegación y análisis del tráfico.
              Puedes aceptar, configurar o rechazar el uso de cookies desde el
              banner de consentimiento al ingresar al sitio.
            </p>
          </section>

          <section data-id="element-487">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-488">
              9. SEGURIDAD DE LA INFORMACIÓN
            </h2>
            <p className="leading-relaxed" data-id="element-489">
              PromRed aplica medidas de seguridad técnicas y organizativas
              adecuadas para proteger tus datos personales contra accesos no
              autorizados, pérdida, destrucción o alteración.
            </p>
          </section>

          <section data-id="element-490">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-491">
              10. CONSERVACIÓN DE LOS DATOS
            </h2>
            <p className="leading-relaxed" data-id="element-492">
              Tus datos serán conservados solo durante el tiempo necesario para
              cumplir con la finalidad para la que fueron recopilados o mientras
              exista una relación institucional o contractual. Posteriormente
              serán eliminados o anonimizados, según corresponda.
            </p>
          </section>

          <section data-id="element-493">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-494">
              11. CAMBIOS A ESTA POLÍTICA
            </h2>
            <p className="leading-relaxed" data-id="element-495">
              Nos reservamos el derecho de modificar esta Política de Privacidad
              en cualquier momento. Cualquier cambio será publicado con la fecha
              de actualización correspondiente.
            </p>
          </section>

          <section data-id="element-496">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-497">
              12. AUTORIDAD DE CONTROL
            </h2>
            <p className="leading-relaxed" data-id="element-498">
              Si consideras que tus derechos no han sido respetados, puedes
              presentar un reclamo ante la Autoridad de Protección de Datos
              Personales de Ecuador, la Superintendencia de Protección de Datos
              Personales.
            </p>
          </section>

          <section data-id="element-499">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-500">13. VIGENCIA</h2>
            <p className="leading-relaxed" data-id="element-501">
              La vigencia de estas Políticas de Privacidad y Protección de Datos
              es desde el 21 de noviembre de 2025 y permanecerá vigente hasta
              que exista una nueva versión que la reemplace.
            </p>
          </section>
        </div>
      </div>
    </div>;
}